<div class="page-wraper">
  <div class="page-title-block bg-transparent flex-wrap flex-sm-nowrap">
    <div class="title-left">
      <h1 class="title h3">Engagement{{router.url == '/dashboard/members/client-engagements' ? ' Info' : 's'}}</h1>
    </div>
    <div class="title-right gap-20 justify-content-start justify-content-lg-end flex-nowrap" *ngIf="router.url == '/dashboard/engagement/engagement-list'">
      <form>
          <mat-form-field class="fixed-label label-none icon-field-before" floatLabel="always" [formGroup]="searchForm">
          <mat-label>Search</mat-label>
              <input matInput formControlName="searchInput" placeholder="Search" maxlength="25"
                     (keyup)="engagementListSearch($event.target.value)">
          <span matSuffix>
            <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
          </span>
        </mat-form-field>
      </form>
      <button mat-button mat-flat-button color="primary" class="button-default btn-width"
              (click)="(acl?.hasEngAdd != true || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress)  || createEngagementDisabled === 4) != true ? createNewEngagement('allEngagements') : ''"
              [disabled]="!firmEngCount || (acl?.hasEngAdd != true || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress || firm?.isPauseInProgress)  || createEngagementDisabled === 4)">
        Create Engagement
      </button>
    </div>
  </div>

  <div class="content-block-main gap-20">

    <div class="cards-group overview-cards gap-20">
      <div class="card flex-1">
        <div class="card-body">
          <h6 class="sub-title textt-gray-6">Engagements</h6>
          <h2 appSpin [spinnerConfig]='spinnerConfig()'>{{totalEngagement? totalEngagement: '-'}}</h2>
        </div>
      </div>
      <div class="card flex-1">
        <div class="card-body">
          <h6 class="sub-title textt-gray-6">New/In Progress</h6>
          <h2 appSpin [spinnerConfig]='spinnerConfig()'>{{current? current: '-'}}</h2>
        </div>
      </div>
      <div class="card flex-1">
        <div class="card-body">
          <h6 class="sub-title textt-gray-6">Completed</h6>
          <h2 appSpin [spinnerConfig]='spinnerConfig()'>{{completed? completed: '-'}}</h2>
        </div>
      </div>
      <div class="card flex-1">
        <div class="card-body">
          <h6 class="sub-title textt-gray-6">Archived</h6>
          <h2 appSpin [spinnerConfig]='spinnerConfig()'>{{archived? archived: '-'}}</h2>
        </div>
      </div>
    </div>


    <div class="button-group justify-content-end w-100" *ngIf="router.url == '/dashboard/members/client-engagements'">
      <button mat-button mat-stroked-button color="dark" class="button-default"
              (click)="(!selectedEngCount || acl?.hasEngDelete != true) != true ? deleteEngDailog() :''"
              [disabled]="!selectedEngCount || acl?.hasEngDelete != true">
              <span class="flexbox-row gap-8">
                <i class="fa-regular fa-trash-can"></i>
                <span class="button-label">Delete</span>
              </span>
      </button>
      <mat-form-field class="fixed-label label-none icon-form-before max-w-200" floatLabel="always">
        <mat-label>Search</mat-label>
        <input matInput placeholder="Search" (keyup)="engagementListSearch($event.target.value)"
               (click)="$event.stopPropagation()" autoComplete="off"
               [disabled]="(acl?.hasEngAdd != true || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress)  ) || createEngagementDisabled">
        <span matPrefix>
            <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
        </span>
      </mat-form-field>
      <button mat-button mat-flat-button color="primary" class="button-default"
              (click)="((acl?.hasEngAdd != true || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress)  ) || createEngagementDisabled) != true?createNewEngagement('clientEngagements'):''"
              [disabled]="!firmEngCount || ((acl?.hasEngAdd != true || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress || firm?.isPauseInProgress)  ) || createEngagementDisabled)">
        <span class="label">Create Engagement</span>
      </button>
    </div>

      <ng-container *ngIf="acl">
        <engagements-list-grid (clearSearch)="clearSearch($event)"
                               [permissions]="acl"></engagements-list-grid>
    </ng-container>

  </div>
</div>

<ng-container *ngIf="acl && !acl.hasEngView">
  <!-- do not have access UI -->
  <div class="cust-overlay-wrappeer">
    <div class="cust-overlay-content">
      <h1 class="flex-box">
        <i class="fa-regular fa-triangle-exclamation warning-msg"></i>
          <span>You do not have access to this page</span>
      </h1>
      <h1>
        <div>Please contact {{loggedInUserData.firmEmailAddress}}</div>
        <div>to provide you access</div>
      </h1>
    </div>
  </div>
</ng-container>

<ng-template #engInfoDialog>
  <div class="countable-dialog confirmation-dailog engInfoDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
      <h4 class="title">Attention</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>

      <div mat-dialog-content class="dialog-body-content">
      <p>Selected engagement(s) status is marked as Completed or Archived</p>
      <p>Please deselect to proceed further</p>
    </div>

      <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]>Ok</button>
    </div>
  </div>
</ng-template>

<ng-template #clientDialog>
  <div class="countable-dialog clientDialog add-engagement-dialog" style="width: 400px;">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-success badge-circle icon-bordered-success">
        <i class="fa-regular fa-check text-success"></i>
      </span>
      <h4 class="title">Engagement Type</h4>
      <p>Select type of engagement you wish to use for this engagement</p>
      <button mat-button class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content overflow-visible">
      <form [formGroup]="selectClientForm" autocomplete="off" class="flexbox-column gap-16">
        <div class="ng-form-field required">
          <label>Client Name</label>
            <ng-select placeholder="Select" [items]="clientsNames" bindValue="clientFirm" [virtualScroll]="true"
                       [clearable]="false" bindLabel="entityName" (change)="clientDetailsChange($event)"
                       formControlName="clientData" [disabled]="selectClientForm.get('clientData').disabled">
          </ng-select>
        </div>
        <div class="ng-form-field required">
          <label>Select Engagement Type</label>
          <ng-select placeholder="Select" [items]="engagementTypes" bindValue="id" [virtualScroll]="true"
            [clearable]="false" bindLabel="engagementType" (change)="selectedEngagementType($event)"
            formControlName="engagementType">
          </ng-select>
        </div>
      </form>
    </div>

    <div mat-dialog-actions class="dialog-footer button-group">
      <button mat-button mat-stroked-button color="dark" class="button-default" [mat-dialog-close]="true"
        (click)="resetChanges()" >Cancel</button>
      <button mat-button mat-flat-button color="primary" class="button-default" [mat-dialog-close]="true"
        (click)="redirectToEngagement()" [disabled]="selectClientForm.invalid">Proceed</button>
    </div>
  </div>
</ng-template>

<ng-template #freeEngagementDialog>
  <div class="countable-dialog freeEngagementDialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div class="dialog-header d-flex flex-column align-items-center">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-circle-info"></i>
      </span>
    </div>
    <div class="content dialog-body-content text-center gap-8">
      <h4 class="title text-center" >Free Engagement Limit to Expire</h4>
      <div >
        <p class="dialogbox">You have 1 free engagement remaining to create under free trial, beyond this you won't be
          able to create any further engagement.</p>
        <p class="dialogbox">Are you sure you want to continue ?</p>
      </div>
    </div>
    <div mat-dialog-actions class="w-100" (click)="$event.stopPropagation()">
      <div class="dialog-footer button-group w-100">
        <button mat-button mat-stroked-button class="flex-1 button-default" color="dark" [mat-dialog-close]>No</button>
        <button mat-button mat-flat-button class="flex-1 button-default" color="primary" [mat-dialog-close]
          (click)="onYesCreateEngagement()">Yes</button>

      </div>

    </div>
  </div>
</ng-template>

